import {lazy} from 'react';

const Homepage = lazy(() => import('./Homepage'));

export default Homepage;
